<script>
    import groups from "./stores/groups";
    import success from './stores/success';
    import {GROUP_TYPE} from './lib/constants';
    import {createEventDispatcher} from 'svelte';
    import {groupLoad, groupSave, validateMobiles} from "./requests";
    import CheckboxControl from './controls/CheckboxControl.svelte';
    import MobilesContainer from "./components/MobilesContainer.svelte";

    const dispatch = createEventDispatcher();

    let group = null;
    let error = null;
    let separateByComma = true;

    let invalidMobiles = '';
    let totalMobiles = 0;
    let totalDoubleMobiles = 0;
    let totalInvalidMobiles = 0;
    let totalValidMobiles = 0;
    let showValidationResults = false;
    let showInvalidMobiles = false;

    let groupTypes = [
        {value: GROUP_TYPE.GROUP_MOBILES, name: 'Τηλέφωνα'},
        {value: GROUP_TYPE.GROUP_MEMBERS, name: "Επαφές"}
    ];

    const separatePhones = () => {
        separateByComma = !separateByComma;
        if (separateByComma) {
            group.mobiles = group.mobiles.replaceAll("\n", ",");
        } else {
            group.mobiles = group.mobiles.replaceAll(",", "\n");
        }
    }


    const open = async () => {
        error = null;

        const [err, res] = await groupLoad($groups.editGroupId);

        if (err) {
            error = err;
            return;
        }

        group = res;
        group.type = parseInt(group.type);
    }

    const close = () => {
        group = null;
        error = null;
        separateByComma = true;
        invalidMobiles = '';
        totalMobiles = 0;
        totalDoubleMobiles = 0;
        totalInvalidMobiles = 0;
        totalValidMobiles = 0;
        showValidationResults = false;
        showInvalidMobiles = false;
        groups.closeGroup();
    }


    const checkForInvalidMobiles = async () => {
        const [err, res] = await validateMobiles(group.mobiles);

        if (!err) {
            totalMobiles = res.total_mobiles;
            totalDoubleMobiles = res.total_double_mobiles;
            totalInvalidMobiles = res.total_invalid_mobiles;
            totalValidMobiles = res.total_valid_mobiles;
            invalidMobiles = res.invalid_mobiles;
            group.mobiles = res.valid_mobiles;
            showValidationResults = true;
            error = null;

            if (invalidMobiles) {
                invalidMobiles = invalidMobiles.replaceAll(",", "<br>");
            }
        }
    }


    const save = async () => {
        error = null;

        if (group.type == GROUP_TYPE.GROUP_MOBILES) {
            group.mobiles = group.mobiles.trim();
            if (group.mobiles.length == 0) {
                error = "Η ομάδα σας δεν περιέχει κινητά τηλέφωνα παραληπτών.";
                return;
            }
        }

        const [err, res] = await groupSave(group);

        if (err) {
            error = err;
            return;
        }

        groups.updateGroup(res);
        if (group.id == 0) {
            if (group.type == GROUP_TYPE.GROUP_MOBILES) {
                success.show("Δημιουργήθηκε νέα ομάδα παραληπτών.");
            } else {
                success.show("Δημιουργήθηκε νέα ομάδα επαφών.");
            }
        } else {
            if (group.type == GROUP_TYPE.GROUP_MOBILES) {
                success.show("Η ομάδα παραληπτών ενημερώθηκε.");
            } else {
                success.show("Η ομάδα επαφών ενημερώθηκε.");
            }
        }

        close();
    }

    const initialize = groupId => {
        if (groupId === undefined || groupId === null) {
            group = null;
        }
        if (groupId !== undefined && groupId !== null && groupId != 0) {
            group = null;
            open();
        }
        if (groupId === 0) {
            group = {
                id: 0,
                type: $groups.editGroupType,
                name: "Νέα ομάδα",
                mobiles: "",
            }
        }
    }

    let searchPhone = '';

    $: {
        initialize($groups.editGroupId);
    }

</script>

{#if group !== null}
    <div class="popup-overlay visible">
        <div class="modal modal-lg">
            <div class="modal-header">
                <div class="modal-title">
                    { group.id == 0 ? "Νέα Ομάδα" : "Επεξεργασία Ομάδας" } { group.type == GROUP_TYPE.GROUP_MOBILES ? "Τηλεφώνων" : "Επαφών" }
                </div>
                <div class="controls-right">
                    <span on:click="{ close }"><i class="fa fa-times"></i></span>
                </div>
            </div>
            <div class="modal-body">
                <label>Όνομα ομάδας</label>
                <div class="form-group">
                    <input type="text" bind:value="{ group.name }" class="form-control" placeholder="όνομα ομάδας">
                </div>
                {#if group.type === GROUP_TYPE.GROUP_MOBILES}
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <CheckboxControl label="Διαχωρισμός τηλεφώνων με κόμμα" checked="{ separateByComma }"
                                                 disabled="{ !group.mobiles }" on:click="{ separatePhones }"/>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-primary btn-block" title="έλεγχος για μη έγκυρους αριθμούς τηλεφώνων"
                                    on:click={ checkForInvalidMobiles }>Έλεγχος
                                τηλεφώνων
                            </button>
                        </div>
                    </div>
                    <hr>
                    {#if showValidationResults}
                        <table class="table table-report mrg-b-none">
                            <tbody>
                            <tr>
                                <td>Σύνολο κινητών:</td>
                                <td class="text-info">{ totalMobiles }</td>
                            </tr>
                            {#if totalDoubleMobiles > 0}
                                <tr>
                                    <td>Διπλά τηλέφωνα:</td>
                                    <td class="text-info">{ totalDoubleMobiles }</td>
                                </tr>
                            {/if}
                            {#if totalInvalidMobiles > 0}
                                <tr>
                                    <td>Λάθος τηλέφωνα</td>
                                    <td class="text-info">
                                        <div class="float-left text-danger">
                                            <strong>{ totalInvalidMobiles }</strong>
                                        </div>
                                        <div class="float-right">
                                            <div class="text-link" title="εμφάνιση τηλεφώνων"
                                                 on:click={ () => showInvalidMobiles = !showInvalidMobiles }>εμφάνιση
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            {/if}
                            <tr>
                                <td>Έγκυρα τηλέφωνα</td>
                                <td class="text-info">{ totalValidMobiles }</td>
                            </tr>
                            </tbody>
                        </table>
                        {#if showInvalidMobiles}
                            <div class="mrg-t-md">
                                <MobilesContainer label="Λάθος τηλέφωνα" mobiles="{ invalidMobiles }"/>
                            </div>
                        {/if}
                        <p class="text-info text-small mrg-b-lg">
                            Τα τηλέφωνα της ομάδας έχουν ενημερωθεί. Αποθηκεύστε για να ισχύσουν οι αλλαγές.
                        </p>
                    {/if}
                    <div class="form-group">
                    <textarea bind:value="{ group.mobiles }" class="form-control"
                              style="height: calc(100vh - 355px);"></textarea>
                    </div>
                {/if}
                {#if (error)}
                    <div class="alert alert-danger text-small"><i class="fa fa-exclamation-triangle"></i> { error }</div>
                {/if}
                <div class="text-right">
                    <button class="btn btn-primary" on:click="{ save }">Ενημέρωση</button>
                    <button class="btn btn-default" on:click="{ close }">Ακύρωση</button>
                </div>
            </div>
        </div>
    </div>
{/if}